export default {
  computed: {
    budgetId () {
      return this.currentBudget ? this.currentBudget.id : 0
    },
    budgetName () {
      return this.currentBudget ? this.currentBudget.name : ''
    },
    budgetAssigned () {
      return this.currentBudget ? this.currentBudget.assigned : 0
    },
    budgetGoal () {
      return this.currentBudget ? this.currentBudget.goal : 0
    },
    isBudgetOwner () {
      return this.currentBudget ? this.currentBudget.imOwner : false
    },
    budgetSpent () {
      return this.currentBudget ? this.currentBudget.spent : 0
    },
    budgetStatus () {
      return this.currentBudget && this.currentBudget.status ? this.currentBudget.status.code : false
    },
    budgetCycle () {
      return this.currentBudget && this.currentBudget.budgetCycle ? this.currentBudget.budgetCycle.code : false
    },
    budgetTagTypes () {
      return this.currentBudget && this.currentBudget.budgetTagTypes.length > 0 ? this.currentBudget.currentBudget.budgetTagTypes : []
    },
    budgetCurrency () {
      return this.currentBudget && this.currentBudget.currency ? this.currentBudget.currency.code : false
    },
    budgetExpirationDate () {
      return this.currentBudget ? this.currentBudget.budgetExpirationDate : ''
    },
    budgetMembershipRenderLabel () {
      return this.isBudgetOwner ? 'budgets_budget_owner' : 'budgets_budget_member'
    },
    assignedBarPercentWidthStyle () {
      return {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: `${this.budgetAssigned <= this.budgetGoal ? (this.budgetAssigned * 100) / this.budgetGoal : 100}%`

      }
    },
    spentBarPercentWidthStyle () {
      return {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: `${(this.budgetSpent * 100) / this.budgetAssigned}%`,
        background: `${this.budgetSpent > this.budgetAssigned ? '#f73647' : '#0089f2'}`
      }
    }

  }

}
